import { FlexLayout } from '../../components/layout/Flex';
import { Profile as ProfileText, Position } from '../../components/Text';

const Profile = () => {
	const resumeLink =
		'https://drive.google.com/file/d/1xbQYnPZLySNgnqhzB3UJc1gugBlRQZJv/view?usp=sharing';

	return (
		<FlexLayout
			style={{
				flexDirection: 'column',
				justifyContent: 'center',
			}}
		>
			<div style={{ padding: '5%' }}>
				<Position>Front-end Developer</Position>
				<ProfileText>in 🧡 with UX / UI</ProfileText>
			</div>
			<div style={{ textAlign: 'right', padding: '5%' }}>
				<ProfileText>{`
				I used to play 🎹
				Happen to spend the most time with ⌨️
				`}</ProfileText>
				<ProfileText>
					Resume is available via <a href={resumeLink}>this link</a> 🔗
				</ProfileText>
			</div>
		</FlexLayout>
	);
};

export default Profile;
